module.exports = __webpack_public_path__ + "static/media/(000105).ea5ab9d9.jpg";